/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetPartnerCreatorsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetPartnerCreatorsArgs, useGetPartnerCreatorsSpec, useGetPartnerCreatorsRealtime, useGetPartnerCreatorsPagination } from '../specs/admin.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetPartnerCreatorsRow } from '../openapi-types.gen.js';
export type { useGetPartnerCreatorsArgs } from '../specs/admin.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetPartnerCreatorsPaginationContract = useGetPartnerCreatorsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetPartnerCreatorsInfinite` — both
 * read/write the same `PagedData<GetPartnerCreatorsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): limit, cursor.
 */
const _useGetPartnerCreators = createListHook({
  spec: useGetPartnerCreatorsSpec,
  realtime: useGetPartnerCreatorsRealtime,
  entityKey: null,
  pagination: _useGetPartnerCreatorsPaginationContract,
});
export const useGetPartnerCreators = _useGetPartnerCreators as (args: useGetPartnerCreatorsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetPartnerCreators>;


/**
 * Auto-infinite: same cache as `useGetPartnerCreators`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetPartnerCreators` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetPartnerCreatorsInfinite = createListHook({
  spec: useGetPartnerCreatorsSpec,
  realtime: useGetPartnerCreatorsRealtime,
  entityKey: null,
  pagination: _useGetPartnerCreatorsPaginationContract,
  autoLoadMore: true,
});
export const useGetPartnerCreatorsInfinite = _useGetPartnerCreatorsInfinite as (args: useGetPartnerCreatorsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetPartnerCreatorsInfinite>;


/**
 * Per-field subscription hook for the `useGetPartnerCreators` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetPartnerCreatorsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetPartnerCreatorsField = createFieldHook<GetPartnerCreatorsRow>('useGetPartnerCreatorsField');

/**
 * Hover/intent prefetch companion for `useGetPartnerCreators` (also covers
 * `useGetPartnerCreatorsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetPartnerCreators();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetPartnerCreators = createPrefetchHook(useGetPartnerCreatorsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetPartnerCreatorsArgs>;
